<template>
    <b-modal
        id="badges-overview-modal"
        v-model="modal"
        :title="$t('common.choose_a_badge')"
        modal-class="apprentice-default-modal badges-overview-modal"
        header-class="badges-overview-header"
        :ok-title="$t('common.add')"
        ok-variant="primary"
        @ok="onOk"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        size="lg">
        <div class="available-badges">
            <div
                class="badge-item"
                v-for="badge of badgesIn"
                :key="badge.id">
                <div
                    :class="['badge', selectedBadge && selectedBadge.id === badge.id && 'selected']"
                    @click="selectBadge(badge)">
                    <img
                        :src="badge.file.public_path"
                        :alt="badge.name" />
                    <div class="badge-name">{{ badge.name }}</div>
                </div>
            </div>
            <div class="badge-item">
                <div
                    :class="[
                        'badge remove-badge',
                        Object.keys(selectedBadge).length === 0 && selectedBadge.constructor === Object && 'selected',
                    ]"
                    @click="selectBadge(null)">
                    <img
                        src="/images/badges/remove-badge.png"
                        :alt="$t('common.no_badge')" />
                    <div class="badge-name">{{ $t('common.no_badge') }}</div>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
import { ords } from '../../../app';

export default {
    name: 'design-2021-apprentice-badges-overview-component',
    props: {
        badgesIn: {
            type: Array,
            required: true,
            default: () => [],
        },
    },

    data() {
        return {
            selectedBadge: {},
            personalGoal: null,
            modal: false,
        };
    },

    methods: {
        show(personalGoal) {
            this.personalGoal = personalGoal;
            this.selectedBadge = personalGoal.badges.length > 0 ? personalGoal.badges[0] : {};
            this.modal = true;
        },

        selectBadge(badge) {
            this.selectedBadge = badge ? badge : {};
        },

        onOk() {
            const data = {
                badge_id:
                    Object.keys(this.selectedBadge).length === 0 && this.selectedBadge.constructor === Object
                        ? null
                        : this.selectedBadge.id,
            };

            this.axios.post(this.routes.addPersonalGoalBadge(this.personalGoal.id), data).then(
                (response) => {
                    ords.hold();
                    if (this.personalGoal.badges.length > 0) {
                        this.personalGoal.badges[0].remove();
                    }

                    if (response.data.badges.length > 0) {
                        this.personalGoal.addRelation('badges', response.data.badges[0]);
                        this.personalGoal.attach('badges', response.data.badges[0].id);
                    }
                    ords.continue();
                },

                (error) => {},
            );
        },
    },
};
</script>

<style scoped lang="scss">
.available-badges {
    display: flex;
    flex-wrap: wrap;
    column-gap: $grid-gutter-width;
    row-gap: $grid-gutter-width;
}

.badge-item {
    display: flex;
}

.badge {
    flex: 1 0 auto;
    width: 125px;
    padding: map-get($grid-gutter-spacing, 'fifteen');
    border: 1px solid $border-color;
    border-radius: $border-radius-content;
    aspect-ratio: 1 / 1;

    img {
        width: 75px;
        height: 75px;
        object-fit: cover;
        object-position: center;
        white-space: pre-wrap;
    }

    &:hover,
    &.selected {
        cursor: pointer;
        transform: scale(1.1);
        transition: transform 85ms ease;
        border-color: var(--primary);

        .badge-name {
            color: $primary;
        }
    }
}

.badge-name {
    margin-top: map-get($grid-gutter-spacing, 'fifteen');
    color: $text-muted-color;
    font-weight: $font-weight-medium;
    white-space: break-spaces;
}
</style>
